<template>
    <van-popup
        v-model="visibleDialog"
        position="bottom"
        closeable
        close-icon="close"
        @close='onClose'
        :closeOnClickModal='false'
        :round="true"
    >
        <div class="conpon">
            <div class="head f32 col333 textCenter">
                服务说明
            </div>
            <div class="server">
                <p><img class="serveImg" src="../../../../../assets/img/b2b/icon_zp.png" alt="">正品保障</p>
                <p class="f28 col333">此商品由好享家平台担保，保证有区域代理/经销权，保证正品行货</p>
            </div>
        </div>
    </van-popup>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible')
        }
    }
}
</script>
<style lang="scss" scoped>
    .conpon {
        background: #ffffff;
        .head {
            position: relative;
            height: 108px;
            line-height: 108px;
            padding: 0 24px;
            .close {
                width: 48px;
                height: 48px;
                position: absolute;
                right: 24px;
                top: 0;
            }
        }
        .server {
            height: 900px;
            padding: 32px;
            .ratePrice {
                margin-bottom: 80px;
            }
            .rabateSm {
                margin-bottom: 48px;
                .title {
                    margin-bottom: 16px;
                }
            }
            .serveImg {
                width: 32px;
                height: 32px;
                vertical-align: sub;
                padding-right: 4px;
            }
        }
    }
    /deep/ .van-popup__close-icon {
        font-size: 44px;
    }
    /deep/ .van-popup__close-icon--top-right {
        top: 30px;
        right: 30px;
    }
</style>
